import AppDialog from 'components/AppDialog'
import AppLayout from 'components/AppLayout'
import { AppTable } from 'components/AppTable'
import React, { Fragment, useState } from 'react'
import OptionAdd from './OptionAdd'

interface Props {
	optionType?: string
	sql?: string
	apiPath?: string
	dataList?: any[]
	colList?: any[]
	callback?: (value: any) => void
}

export const OptionSet = (props: Props) => {
	const OptionList = [
		{ label: '固定值', value: 'default' },
		{ label: 'SQL语句', value: 'sql' },
		{ label: 'API', value: 'apiPath' },
	]
	const [optionType, setOptionType] = useState(props.optionType || 'default')
	const [dataList, setDataList] = useState(props.dataList || ([] as any[]))
	const [colList, setColList] = useState(
		props.colList || [{ field: 'value', title: '值' }, { field: 'label', title: '标签' }]
	)
	const [sql, setSql] = useState(props.sql || '')
	const [apiPath, setApiPath] = useState(props.apiPath || '')

	const handleRadio = () => {
		switch (optionType) {
			// case 'default': // 固定值
			// 	return (
			// 		<AppLayout.ColFix>
			// 			<AppLayout mode="col">
			// 				<AppMenu>
			// 					<AppRightMenu>
			// 						<AppAction title="新增行" type="primary" action={addRow} />
			// 						{/* <AppAction title='新增列' action={this.AddCol} /> */}
			// 					</AppRightMenu>
			// 				</AppMenu>
			// 				<AppLayout.ColFix>
			// 					<AppTable key={Math.random()} dataSource={dataList}>
			// 						<AppTable.ColIndex />
			// 						{/* {head && head.length > 0 ? <AppTable.ColIndex title="序号" width={50} /> : null} */}
			// 						{colList.map((col, index) => {
			// 							return (
			// 								<AppTable.Col
			// 									title={col.title}
			// 									field={col.field}
			// 									key={'field' + col + index}
			// 								/>
			// 							)
			// 						})}
			// 						<AppTable.ColAction
			// 							width={100}
			// 							render={(data: any, index: number) => {
			// 								return <TableAction label="删除" onClick={e => delRow(index)} />
			// 							}}
			// 						></AppTable.ColAction>
			// 					</AppTable>
			// 				</AppLayout.ColFix>
			// 			</AppLayout>
			// 		</AppLayout.ColFix>
			// 	)
			// case 'sql': // SQL语句
			// 	return (
			// 		<AppLayout.ColFix>
			// 			<AppForm>
			// 				<AppTextArea label="SQL语句" value={sql} onChange={setSql} />
			// 			</AppForm>
			// 		</AppLayout.ColFix>
			// 	)
			// case 'apiPath': // API
			// 	return (
			// 		<AppLayout.ColFix>
			// 			<AppForm>
			// 				<AppInput label="ApiPath" value={apiPath} onChange={setApiPath} />
			// 			</AppForm>
			// 		</AppLayout.ColFix>
			// 	)
			default:
				return <Fragment />
		}
	}

	const addRow = () => {
		AppDialog.open(<OptionAdd colList={colList} onchange={addData} index={dataList.length} />)
	}

	const delRow = (index: number) => {
		let dataListNew = [...dataList]
		dataListNew.splice(index, 1)
		setDataList(dataListNew)
	}

	const addData = (value: any) => {
		let dataListNew = [...dataList]
		dataListNew.push(value)
		setDataList(dataListNew)
	}

	const onsave = () => {
		let ReturnValue = {}
		const type = 'optionType'
		switch (optionType) {
			case 'default':
				ReturnValue[type] = 'default'
				let name = 'dataList'
				ReturnValue[name] = dataList
				break
			case 'sql':
				ReturnValue[type] = 'sql'
				name = 'sql'
				ReturnValue[name] = sql
				break
			case 'apiPath':
				ReturnValue[type] = 'api'
				name = 'apiPath'
				ReturnValue[name] = apiPath
				break
		}
		console.log('ReturnValue', ReturnValue)
		props.callback && props.callback(ReturnValue)
		AppDialog.close()
		//
	}

	const close = () => {
		AppDialog.close()
	}

	return (
		<AppLayout mode="col">
			{/* <AppForm colNumber={2} labelWidth={10}>
				<AppFormLabel value="类型选择:" />
				<AppFormRadio appFormItemOptionList={OptionList} onChange={setOptionType} value={optionType} />
			</AppForm>
			{handleRadio()}
			<AppFormMenu>
				<AppAction title="保存" type="primary" action={onsave} />
				<AppAction title="取消" action={close} />
			</AppFormMenu> */}
		</AppLayout>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/OptionSet.tsx